<template>
  <div class="message-container d-flex justify-content-begin mb-2 inbound" :id="getId">
    <div class="message">
      <div class="header font-weight-bold">
        <span class="contact-filemaker-id">{{ getEmailContext || getEmail | uppercase }}</span>
        <span class="contact-full-name">{{ contactFullName | uppercase }}</span>
      </div>
      <div class="content d-flex flex-column" :style="styles" :class="{active: isHighlight}">
        <div class="content-body w-100 d-flex flex-column">
          <div class="message-subject d-flex w-100 cursor-pointer">
            <div class="wrapper w-100" @click.prevent="onShowBody">
              <span style="font-size: 24px; vertical-align: middle;" class="mr-2">
                <i class="fas fa-envelope"></i>
              </span>
              <b>Subject:</b> {{ getSubject }}
              <i class="fas ml-2 mr-1" v-bind:class="[showBody ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
            </div>
            <message-settings :settings="emailMessageSettings" :message="message"></message-settings>
          </div>
          <div class="w-100 mt-2" v-if="showBody">
            <iframe-loader :url="getPreviewUrl"></iframe-loader>
          </div>
        </div>
      </div>
      <div class="footer text-black-50">
        {{ statusString | uppercase }}
      </div>
    </div>
  </div>
</template>

<script>
import ChatMailMessage from "./chat-mail-message";
import MessageSettings from "../message-settings";
import eventBus from "../../../event-bus";
import IframeLoader from "../../iframe-loader";

export default {
  extends: ChatMailMessage,

  components: {
    MessageSettings,
    IframeLoader,
  },

  computed: {
    /**
     * @return {String}
     */
    getEmail() {
      return _.get(this.contact, 'email');
    },

    /**
     * @return {String}
     */
    getEmailContext() {
      return _.get(this.contact, 'email_context');
    },

    /**
     * @return {String|null}
     */
    contactFullName() {
      return _.get(this.contact, 'full_name', null);
    },

    /**
     * @return {Object|null}
     */
    messageCreatedAt() {
      return _.get(this.message, 'email_message.created_at', null);
    },

    /**
     * @return {String}
     */
    statusString() {
      return 'MESSAGE RECEIVED: ' + (this.formatTime(this.messageCreatedAt) || '');
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'other.item.text.color': color,
        'other.item.background.color': backgroundColor
      } = {...this.brand.styles};

      // remove empty values
      return _.pickBy({color, backgroundColor}, _.identity);
    },

    /**
     * @return {Number}
     */
    getId() {
      return _.get(this.message, 'email_message.id');
    },
  },

  methods: {
    /**
     * @param id
     */
    highlightMessage({id}) {
      if (this.getId !== id) {
        return;
      }

      this.isHighlight = true;

      setTimeout(() => {
        this.isHighlight = false;
      }, 5000);
    },
  },

  created() {
    eventBus.$on('highlight-email-message', this.highlightMessage);
  },

  beforeDestroy() {
    eventBus.$off('highlight-email-message', this.highlightMessage);
  },
}
</script>

<style scoped>

</style>
